import { checkResponseType, Crud, HttpClient, httpClient, RequestResponse } from 'lib/HttpClient';
import {
    isTenant as isTenantSdk,
    isTenantApiKey as isTenantApiKeySdk,
    ITenant,
    ITenantApiKey
} from '@pepperhq/types-sdk';
import { isString } from 'lib/typeguards';

export function isTenant(obj: unknown): obj is ITenant<string, string> {
    return isTenantSdk(obj, isString, isString);
}

export function isTenantApiKey(obj: unknown): obj is ITenantApiKey<string> {
    return isTenantApiKeySdk(obj, isString);
}

class TenantsApi extends Crud {
    constructor(client: HttpClient) {
        super(client, import.meta.env.API_SERVER_URL, 'tenants', {
            'x-auth-id': import.meta.env.CONSOLE_FIREBASE_PROJECT_ID
        });
    }

    public async createAppId(
        tenantId: string,
        appId: string
    ): Promise<RequestResponse<ITenant<string, string>>> {
        const response = await this.httpClient.post(`${this.api}/tenants/${tenantId}/applicationIds`, {
            body: { appId }
        });
        return checkResponseType(response, isTenant);
    }

    public async createApiKey(
        tenantId: string,
        description: string,
        appIdPrefix?: string
    ): Promise<RequestResponse<ITenantApiKey<string>>> {
        const response = await this.httpClient.post(`${this.api}/tenants/${tenantId}/apiKeys`, {
            body: { description, appIdPrefix }
        });
        return checkResponseType(response, isTenantApiKey);
    }

    public async updateApiKey(
        tenantId: string,
        applicationId: string,
        body: { isDisabled: boolean }
    ): Promise<RequestResponse<ITenant<string, string>>> {
        const response = await this.httpClient.put(
            `${this.api}/tenants/${tenantId}/apiKeys/${applicationId}`,
            {
                body
            }
        );
        return checkResponseType(response, isTenant);
    }

    public async deleteApiKey(
        tenantId: string,
        applicationId: string
    ): Promise<RequestResponse<ITenant<string, string>>> {
        const response = await this.httpClient.delete(
            `${this.api}/tenants/${tenantId}/apiKeys/${applicationId}`
        );
        return checkResponseType(response, isTenant);
    }
}

export const tenantsApi = new TenantsApi(httpClient);
